module.exports = __webpack_public_path__ + "static/media/footballer.e45961d4.jpg";